import { prisma } from '../../shared/prisma';
import { AppError } from '../../shared/errors/AppError';

export async function createChannel(teamId: string, userId: string, data: { name: string; description?: string; isPrivate?: boolean }) {
  const channel = await prisma.channel.create({
    data: { teamId, ...data, members: { create: { userId, role: 'owner' } } },
  });
  return channel;
}

export async function listChannels(teamId: string, userId: string) {
  return prisma.channel.findMany({
    where: {
      teamId,
      isArchived: false,
      OR: [{ isPrivate: false }, { members: { some: { userId } } }],
    },
    include: { _count: { select: { members: true } } },
    orderBy: { name: 'asc' },
  });
}

export async function getChannel(channelId: string) {
  const channel = await prisma.channel.findUnique({
    where: { id: channelId },
    include: { members: { include: { user: { select: { id: true, displayName: true, avatarUrl: true } } } } },
  });
  if (!channel) throw new AppError(404, 'Channel not found');
  return channel;
}

export async function archiveChannel(channelId: string) {
  return prisma.channel.update({ where: { id: channelId }, data: { isArchived: true } });
}

export async function joinChannel(channelId: string, userId: string) {
  return prisma.channelMember.upsert({
    where: { channelId_userId: { channelId, userId } },
    update: {},
    create: { channelId, userId },
  });
}

export async function leaveChannel(channelId: string, userId: string) {
  return prisma.channelMember.delete({ where: { channelId_userId: { channelId, userId } } });
}

export async function markAsRead(channelId: string, userId: string) {
  return prisma.channelMember.update({
    where: { channelId_userId: { channelId, userId } },
    data: { lastReadAt: new Date() },
  });
}
